import React, { useEffect } from 'react'
import { logoutUser, getRefreshToken } from 'actions/loginActions'
import { useStateValue } from 'context/store'
import { withRouter } from 'react-router-dom'
import debounce from 'lodash/debounce'

import { loadState } from 'utils/localStorage'
import { LOCALSTORAGE_KEYS, VALUES } from 'utils/constants'
import { openModalAction } from 'context/reducers/modalReducer'
import { closeSnackbarAction } from 'context/reducers/openSnackbarReducer'

let originalXMLHttpRequest = XMLHttpRequest

const CLOSE_SESSION_MESSAGE = <><div style={{ marginBottom: 10, fontSize: 18 }}><b>Sesión caducada</b></div> <div>Señor usuario, su sesión ha sido cerrada por inactividad. Por favor, inicie sesión nuevamente.</div></>

const INACTIVITY_TIME = VALUES.SESSION_TIME_EXPIRATION
const INTERVAL_DELAY = 2000
let inactivityTime = INACTIVITY_TIME
let refreshTokenExpireTime = null
let intervalID = null

const NO_INACTIVITY_HTTP_REQUEST = JSON.parse(process.env.REACT_APP_NO_SESSION_EXPIRATION_URL || [])
const USER_EVENTS = ['click', 'mousemove', 'keyup', 'wheel']

const SessionExpiration = ({ history }) => {
   const [{ sessionUser }, dispatch] = useStateValue()

   const addUserEventListeners = () => {
      USER_EVENTS.forEach(event => window.addEventListener(event, restartInactivityTime, false))
   }
   const removeUserEventListeners = () => {
      USER_EVENTS.forEach(event => window.removeEventListener(event, restartInactivityTime, false))
   }

   const resetInactivityTime = (enhancedTime = 0) => {
      inactivityTime = INACTIVITY_TIME * (enhancedTime + 1)
   }

   const restartInactivityTime = debounce(() => {
      resetInactivityTime()
   }, 400)

   const setRefreshTokenTime = (refresh_expires_in) => {
      const refreshExpiresInMills = refresh_expires_in ? (Date.now() + refresh_expires_in * 1000) : loadState()?.token?.refresh_expiration_date
      const OFFSET = 100 * INTERVAL_DELAY
      refreshTokenExpireTime = refreshExpiresInMills - OFFSET
      console.log('next token refresh:', new Date(refreshTokenExpireTime))
   }

   const isAnInactivityURLRequest = url =>
      NO_INACTIVITY_HTTP_REQUEST.some(urlItem => url.includes(urlItem))

   const tracerCallback = xhr => {
      const responseURL = xhr.responseURL
      const isURLFound = isAnInactivityURLRequest(responseURL)
      if (isURLFound) resetInactivityTime()
      return xhr
   }

   const initHTTPTracer = () => {
      XMLHttpRequest = function () {
         const xhr = new originalXMLHttpRequest();
         xhr.onload = () => {
            tracerCallback(xhr)
         }
         return xhr
      };
   }

   const closeSession = () => {
      clearInterval(intervalID)
      dispatch(openModalAction({
         icon: 'warning',
         message: CLOSE_SESSION_MESSAGE,
         hideCloseButton: true,
         confirmButtonText: "Entendido"
      }))
      dispatch(closeSnackbarAction())
      logoutUser(dispatch, loadState()?.token?.refresh_token, history)
      console.log('>>> CLOSE SESSION')
   }

   const refreshToken = async () => {
      const payload = {
         refreshToken: loadState()?.token?.refresh_token,
         username: sessionUser?.settings?.email
      }
      try {
         const res = await getRefreshToken(payload)
         const { access_token, refresh_expires_in } = res.data
         setRefreshTokenTime(refresh_expires_in)
         localStorage.setItem(LOCALSTORAGE_KEYS.TOKEN_APP, access_token)
         await dispatch({
            type: 'LOGIN_SESSION',
            session: res.data,
            authenticated: true,
            accessToken: access_token
         })
      } catch (error) {
         console.log('refresh token error: ', error)
         closeSession()
      }
   }

   const evalInactivityTime = () => {
      inactivityTime -= INTERVAL_DELAY
      if (inactivityTime <= 0) {
         closeSession()
         return true
      }
   }

   const evalRefreshTokenTime = async () => {
      if (Date.now() > refreshTokenExpireTime) await refreshToken()
   }

   const activateInterval = () => {
      intervalID = setInterval(() => {
         if (evalInactivityTime()) return
         evalRefreshTokenTime()
      }, INTERVAL_DELAY)
   }

   useEffect(() => {
      initHTTPTracer()
      setRefreshTokenTime()
      addUserEventListeners()
      activateInterval()
      return () => {
         console.log('>>> session inactivity module disabled');
         clearInterval(intervalID)
         removeUserEventListeners()
      }
   }, [])

   return <></>

}

export default withRouter(SessionExpiration)
